import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

function mapStateToProps(state) {
  const { lang, messages } = state.locale;
  return { locale: lang, key: lang, messages };
}

/**
 * This class connects IntlProvider from 'react-intl' to the lang and message state,
 * so when state changes, all strings re renders.
 */
export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./components/ReduxConnectedIntlProvider.js